module.exports = __webpack_public_path__ + "linkedin-8de35bde.png";